var map = {
	"./SignPainter-HouseScript.ttf": 135,
	"./proximasoft-bold-webfont.ttf": 139,
	"./proximasoft-regular-webfont.ttf": 144
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56;



//////////////////
// WEBPACK FOOTER
// ./themes/mf/font ^\.\/.*\.ttf$
// module id = 56
// module chunks = 3